<header class="justify-items-around fixed-top-header">
  <!-- style="z-index: 10;fixed-top" -->
  <div id="section-top-header" class="d-flex justify-content-between align-items-center px-2"
  [ngStyle]="{'background-color': sectionHeader?.top_header}">
    <div class="d-flex justify-content-start align-items-center text-truncate align-self-center px-0"
      style="height: 31px !important; right: 50px;">
      <ul class="nav justify-content-xg-end justify-content-lg-end">

        <!-- <li class="nav-item mr-3">
          <i class="bi bi-whatsapp text-white"></i>
          <a href="https://wa.me/{{wsp_number}}" target="_blank" rel="noopener noreferrer" class="font-phone">&nbsp;{{ getClientsSettingAppBooking?.wsp_phone_number }}</a>
        </li> -->
        <li class="nav-item d-flex align-items-center">
          <i class="bi bi-telephone-fill text-white"></i>
          <p class="mb-0 font-phone">&nbsp;{{ getClientsSettingAppBooking?.phone_number_one }}</p>
        </li>
        <li class="nav-item help-container ml-3 mt-1 align-self-center">
          <a href="https://help.fusionpax.com/" target="_blank" class="mx-2" title="help"><i class="bi bi-question-circle-fill" style="font-size: 19px"></i></a>
        </li>
      </ul>
    </div>
    <div class="d-flex justify-content-end text-truncate align-self-center  px-0" style="height: 31px !important;">
      <ul class="nav justify-content-end" >
        <!-- <li class="nav-item help-container mr-3 mt-1 align-self-center">
          <a href="https://help.fusionpax.com/" target="_blank" class="mx-2" title="help"><i class="bi bi-question-circle-fill" style="font-size: 19px"></i></a>
        </li> -->
        <li class="nav-item ml-3 mt-1 align-items-center d-flex" *ngIf="getClientsSettingAppBooking?.clients_setting_social_networks[1]?.url != ''">
            <a [href]="getClientsSettingAppBooking?.clients_setting_social_networks[1]?.url" target="_blank" rel="noopener noreferrer">
              <i class="bi bi-instagram" style="font-size: 19px"></i>
            </a>
          </li>
          <li class="nav-item ml-3 mt-1 align-items-center d-flex" *ngIf="getClientsSettingAppBooking?.clients_setting_social_networks[3]?.url != ''">
            <a [href]="getClientsSettingAppBooking?.clients_setting_social_networks[3]?.url" target="_blank" rel="noopener noreferrer">
              <i class="bi bi-linkedin" style="font-size: 19px"></i>
            </a>
          </li>
          <!-- <li class="nav-item ml-3 mt-1 align-items-center d-flex pr-3" *ngIf="getClientsSettingAppBooking?.clients_setting_social_networks[0]?.url != ''">
            <a [href]="getClientsSettingAppBooking?.clients_setting_social_networks[0]?.url" target="_blank">
              <i class="bi bi-facebook" style="font-size: 19px"></i>
            </a>
          </li> -->
           <li *ngIf="executiveData" class="nav-item help-container px-3 ml-3 align-items-center d-flex">
            <p class="mb-0 font-phone" style="cursor: pointer" (click)="openModalFormOffline()">Cotización off line</p>
           </li>
          <li *ngIf="executiveData" class="nav-item ml-3 align-items-center d-flex" (click)="sidebardSupport()" style="gap:.5em;">
            <i class="bi bi-headset" style="font-size: 14px;color: white;"></i>
            <p class="mb-0 font-phone" style="cursor: pointer" >Atención al cliente</p>
          </li>
           <li class="nav-item help-container px-3 ml-3 align-items-center d-flex">
            <p class="mb-0 font-phone" style="cursor: pointer" (click)="openSuggestionSystem()">Sugerencias de sistema</p>
           </li>

           <div class="sidebar-right" style="background-color: white" [class.show]="sidebarSuggestionSystem">
                <div class="d-flex justify-content-end pr-2 align-items-center" style="height: 48px;" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}">
                  <button (click)="closeSuggestionSystem()" [attr.aria-expanded]="!isCollapsed" aria-controls="false"
                      style="background-color: transparent;border:none; font-size: 30px; font-weight: 400;color: white">
                        x
                      </button>
                </div>

                <form *ngIf="formSuggestionSystem" style="padding-left: 1.75em;padding-right: 1.75em;"  [formGroup]="formSuggestionSystem" (ngSubmit)="sendSuggestionSystem()">
                  <h2 class="mb-0 section-title mt-4" style="line-height: 1;padding-bottom: 0px">Envía tu sugerencia</h2>
                   <p class="mb-4" style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400;line-height: 1;color: #8b8b8b;">Ayudanos a mejorar tu experiencia de reservas...</p>

                    <div class="mb-3 d-flex flex-column" style="width: 100%; position: relative">
                      <label class="ml-2 custom-label" for="module">Módulo</label>
                      <select formControlName="module"
                              name="module"
                              class="form-control custom-input form-select custom-select-arrow"
                              style="border: 1px solid black;"
                              id="module">
                          <option value="null" selected disabled>Seleccione un módulo</option>
                        <ng-container *ngFor="let module of availableModules">
                          <option value="{{module.label}}">{{module.label}}</option>
                        </ng-container>
                        <option value="Otro">Otro...</option>
                      </select>
                        <span style="position: absolute; top: 65%; right: 1em;
                                    width: 0;
                                    height: 0;
                                    border-left: 5px solid transparent;
                                    border-right: 5px solid transparent;"
                        [ngStyle]="{'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"></span>
                    </div>

                 <div class="mb-3 d-flex flex-column" style="width: 100%">
                    <label class="ml-2 custom-label" for="title">Título</label>
                    <input formControlName="title"
                          type="text"
                          class="form-control custom-input"
                          placeholder="voucher sin poder emitir"
                          maxLength="30">
                    <p class="mb-0 ml-2 custom-counter">
                      {{formSuggestionSystem.get('title')?.value && formSuggestionSystem.get('title')?.value?.length > 0 ? formSuggestionSystem.get('title')?.value?.length : 0 }}/30 carácteres como máximo
                    </p>
                  </div>

                  <div class=" d-flex flex-column" style="width: 100%">
                    <label class="ml-2 custom-label" for="description">Descripción</label>
                    <textarea formControlName="description"
                              name="description"
                              rows="5" cols="33"
                              class="form-control custom-textarea"
                              placeholder="¿Qué esperabas?¿Qué ocurrió?¿donde ocurrió? Ej. En el file 135, al generar el voucher el botón 'descargar voucher' estaba deshabilitado. Esperaba ver el botón activo."
                              maxLength="200"
                              id="description">
                    </textarea>
                    <p class="mb-0 ml-2 custom-counter">
                      {{formSuggestionSystem.get('description')?.value && formSuggestionSystem.get('description')?.value.length > 0 ? formSuggestionSystem.get('description')?.value.length : 0 }}/200 carácteres como máximo
                    </p>
                  </div>

                  <div class="d-flex align-items-center" style="gap: .5em;margin-top: 1.75em; margin-bottom: 1.75em;">
                    <input type="checkbox" class="black-checkbox" formControlName="contact_available">
                    <p  class="mb-0" style="font-family: 'Rubik', serif; font-weight: 600;font-size: 16px;">¿Podemos contactarte?</p>
                  </div>

                      <div class="d-flex justify-content-end" style="gap: .5em;">
                        <button type="button"
                                class="btn btn-continue"
                                style="background-color: #ececec"
                                (click)="resetFormSuggestionSysytem()">Borrar</button>
                        <button type="submit"
                                class="btn btn-continue"
                                [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                                >Enviar</button>
                      </div>
                </form>




           </div>

        <div class="sidebar-right" style="background-color: white" [class.show]="sidebarSupportShow">

          <div class="d-flex justify-content-end pr-2 align-items-center" style="height: 48px;" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}">
            <button (click)="closeSidebardSupport()" [attr.aria-expanded]="!isCollapsed" aria-controls="false"
                 style="background-color: transparent;border:none; font-size: 30px; font-weight: 400;color: white">
                  x
            </button>
          </div>


          <ul style="list-style: none;padding: 1rem">

            <div *ngIf="executiveData" class="executive-profile">
              <!-- Avatar con fallback accesible -->
                <h2 class="section-title">Atención al cliente 24/7</h2>
                <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400;line-height: 1;margin-bottom: 5px;">¿Necesitas asistencia?</p>
                <p style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400;line-height: 1;">Estamos listos para atenderte</p>

                <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 12px; font-weight: 400;line-height: 1;color: #6c6b72">Mejora tu experiencia con apoyo experto</p>
                <p style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 600;line-height: 1;">Tú ejecutivo de ventas</p>

                <div class="d-flex flex-column pt-4" style="background-color: #e8e8e9; border-radius: 8px;">
                  <div class="d-flex align-items-center px-5 mb-3" style="gap: 2em;">
                    <div style="width: 40%" style="position: relative">
                      <div class="avatar-container" [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_1}" role="img" [attr.aria-label]="'Foto de perfil de ' + executiveData.first_name">
                        <img *ngIf="executiveData.image_profile; else noAvatar"
                            [src]="bookingApiStorage + executiveData.image_profile"
                            alt=""
                            class="avatar-image">
                        <ng-template #noAvatar>
                          <div class="avatar-fallback">
                            {{ executiveData.first_name.charAt(0) }}{{ executiveData.last_name.charAt(0) }}
                          </div>
                        </ng-template>
                        <div class="c3"></div>
                      </div>
                      <i class="bi bi-arrow-up-right-circle-fill"
                        style="position:absolute; bottom: -1px; right: 0;font-size: 1.8rem; cursor: pointer"
                        tooltip="{{urlSafe ? 'Video de presentación' : 'El ejecutivo de ventas no cuenta con video de presentación'}}"
                        placement="bottom"
                        (click)="openVideoModal(urlSafe)"></i>
                    </div>
                    <div style="width: 60%">
                      <p style="font-family: 'Rubik', serif;font-size: 15px; font-weight: 600;line-height: 1;text-wrap: auto;">{{ executiveData.first_name }} {{ executiveData.last_name }}</p>
                      <p style="font-family: 'Rubik', serif;font-size: 15px; font-weight: 400;line-height: 1;"><a href="#"
                                                                                                                  (click)="openWhatsApp()"
                                                                                                                  style="color: black; text-decoration: none; cursor: pointer;margin: 0px;">
                                                                                                                   + {{ executiveData.phone_code_wsp }} {{ executiveData.wsp_phone_number }}
                                                                                                                </a></p>
                      <div>
                        <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 13px; font-weight: 400;line-height: 1;">Email:</p>
                        <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 13px; font-weight: 400;line-height: 1;"><a href="#"
                                                                                                                              (click)="openEmailWithSubject($event, true)"
                                                                                                                              style="color: black; text-decoration: none;margin: 0px;">
                                                                                                                                {{ executiveData.email }}
                                                                                                                            </a></p>
                      </div>
                    </div>
                  </div>
                  <div class="px-5 pb-4">
                    <select (change)="executiveHelpSelected($event.target.value)" class="form-control" name="" id="" style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400;">
                      <option value="null" disabled="true" selected style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400;">¿Cómo puede ayudarte el ejecutivo de ventas?</option>
                      <ng-container *ngFor="let info of infos">
                        <option style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400;" value="{{info}}">{{info}}</option>
                      </ng-container>
                    </select>
                  </div>
                </div>
              </div>



                <div class="custom-accordion">
  <!-- Acordeón principal -->
  <div class="accordion-item" [class.expanded]="isMainExpanded">
    <div class="accordion-header"
         (click)="toggleMainAccordion()"
         [style.background-color]="'#f2fbf7'">
      <span class=" mb-0 accordion-title ml-2">Contactos de otros departamentos</span>
      <span class="accordion-icon" [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1">{{isMainExpanded ? '▼' : '▲'}}</span>
    </div>

    <div class="accordion-content mt-3" *ngIf="isMainExpanded">

      <!-- Acordeones secundarios -->
      <div class="nested-accordion">
        <ng-container *ngFor="let segment of segmentClient; let i = index">
          <div class="accordion-item mb-2" [class.expanded]="expandedSegment === i">
            <div class="accordion-header nested-header"
                 (click)="toggleSegment(i)">
              <span class="accordion-title ml-2">{{segment.title}}</span>
              <span class="accordion-icon" [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1">{{expandedSegment === i ? '▼' : '▲'}}</span>
            </div>

            <div class="accordion-content nested-content ml-2"   *ngIf="expandedSegment === i">
              <div class="content-body" >
                <p class="mb-4" style="font-family: 'Rubik', serif;font-size: 13px; font-weight: 400;line-height: 1;text-wrap: auto;">{{segment.description}}</p>

                <div class="d-flex flex-column pb-4" style="border-bottom: 1px dashed #919191; ">
                  <ng-container *ngFor="let contact of segment.contacts">

                    <p class="mb-4" style="font-family: 'Rubik', serif;font-size: 13px; font-weight: 400;line-height: 1;text-wrap: auto;">Horarios: {{contact.schedule}}</p>

                    <div class="d-flex mb-3">
                      <div class="d-flex flex-column" style="width: 100%">
                        <p class="mb-1" style="font-family: 'Rubik', serif;font-size: 12px; font-weight: 400;line-height: 1;color: #6c6b72">Email</p>

                        <span *ngFor="let email of contact.emails">
                            <!-- <a class="mb-0 mt-0" style="font-family: 'Rubik', serif;font-size: 15px; font-weight: 400;line-height: 1;text-wrap: auto;"
                        [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1" [href]="'mailto:' + email">{{email}}</a>  -->

                        <a href="#"
                                                                                                                              (click)="openEmailWithSubject($event, false)"
                                                                                                                               [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1"
                                                                                                                              class="mb-0 mt-0" style="font-family: 'Rubik', serif;font-size: 15px; font-weight: 400;line-height: 1;text-wrap: auto;margin-bottom: 5px !important">
                                                                                                                                {{ email }}
                                                                                                                            </a>
                          </span>

                      </div>

                      <div class="d-flex flex-column" style="width: 100%">
                        <p class="mb-1" style="font-family: 'Rubik', serif;font-size: 12px; font-weight: 400;line-height: 1;color: #6c6b72">Teléfono/whatsapp</p>
                        <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 15px; font-weight: 400;line-height: 1;text-wrap: auto;"
                        [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1">{{contact.phone}}
                        </p>
                      </div>

                    </div>
                  </ng-container>
                </div>
                <div *ngIf="(!segment.contacts || segment.contacts.length === 0) && !segment.description" class="no-content">
                  No hay información disponible para este departamento.
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

    </div>
  </div>
</div>

            </ul>
          </div>
        </ul>
      </div>
  </div>


  <!-- <div [ngStyle]="{'background-color': sectionHeader?.background_header}" class="d-flex justify-content-between"> -->
    <div style="background-color: white; height:110px;">

      <div  class="d-flex justify-content-between" style="height: 55px;">
        <div class="d-flex align-items-center">
          <!-- Botón para abrir sidebar -->
          <button class="btn" (click)="openSidebar()">
            <i [ngStyle]="{'color': sectionHeader?.color}" class="bi bi-list" style="font-size: 2rem; -webkit-text-stroke-width: 1px;"></i>
          </button>

          <!-- Sidebar lateral -->
          <div class="sidebar" [ngStyle]="{'background-color': sectionHeader?.top_header}" [class.show]="sidebarVisible">

              <ul style="list-style: none;padding-left: 0px !important;">
                <li role="menuitem">
                  <button (click)="closeSidebar()" [attr.aria-expanded]="!isCollapsed" aria-controls="false"
                    class="btn btn-outline-light btn-sm mb-4 mt-3">
                    <i class="fa fa-times" ></i>
                  </button>
                </li>
                <li class="dropdown-separador"></li>
                <ng-container *ngFor="let item of items">
                  <ng-container *ngIf="(!item.permissionKey || permissionsMap[item.permissionKey]) && item.client">
                    <li role="menuitem">
                      <p class="dropdown-item mb-0" style="cursor:pointer" (click)="item.action()">
                        {{ item.label }}
                      </p>
                    </li>
                    <li *ngIf="item.dividerAfter" class="divider dropdown-divider"></li>
                  </ng-container>
                </ng-container>
              </ul>
          </div>

          <!-- Fondo oscuro -->
          <div class="overlay" [class.show]="sidebarVisible" (click)="closeSidebar()"></div>

          <div class="flex-grow-1" style="width: 190px;">
            <img  src="{{routeUploadFile+getClientsSettingAppBooking?.logo_path_one }}"
                  alt="Logo Booking"
                  class="d-block logo-booking"
                  style="cursor: pointer;width: 100%;max-height: auto;aspect-ratio: 2/1;object-fit: contain;"
                  (click)="_home()">
          </div>

      </div>
      <div class="d-flex justify-content-end" style="width: 75%">
        <div class="d-flex flex-column justify-content-center px-3" style="border-bottom-left-radius: 20px;" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}">
          <div class="d-flex align-items-center">
               <img src="../../../../assets/icons/header/wsp.svg" style="width: 18px;" alt="" >
              <p [ngStyle]="{'color': sectionHeader?.color}" class="font-menu datos-header-right mb-0 ml-1" style="font-size: 12px !important; font-weight: 400;">Contacto directo</p>
          </div>
            <a href="https://wa.me/{{wsp_number}}" target="_blank" rel="noopener noreferrer" [ngStyle]="{'color': sectionHeader?.color}" style="font-family: 'Poppins';font-size: 12px; font-weight: 600;">&nbsp;{{ getClientsSettingAppBooking?.wsp_phone_number }}</a>

        </div>
        <div class="d-flex flex-column justify-content-center pl-3 pr-5" style="background-color: #f3f5f5; border-right: 1px solid white;">

          <div class="d-flex align-items-center">

            <div class="d-flex flex-column"
                  tooltip="Saldo blickoins"
                  style="cursor: pointer"
                  *ngIf="!permissionsMap['booking.ingresosinagencia']"
                   (click)="goTo('pointxagent')"
                    placement="bottom">
              <p [ngStyle]="{'color': sectionHeader?.color}" class="font-menu datos-header-right mb-0" style="font-size: 12px !important; font-weight: 400;">Rewards</p>
              <div class="d-flex align-items-center pr-4" style="border-right: 2px solid white;">
                <img src="../../../../assets/icons/header/bks.svg" style="width: 20px;" alt="" >
                <p class="mb-0  ml-1"
                [ngStyle]="{'color': sectionHeader?.color}"
                  (click)="goTo('pointxagent')"
                   style="font-family: 'Poppins', sans-serif;font-size: 12px; font-weight: 600; ">
                  BKS {{ userService.balanceBlickoins ? (userService.balanceBlickoins | number: '1.2-2') : 0}}
                </p>
              </div>
            </div>

            <div class="d-flex flex-column"
                  tooltip="Créditos blickoins"
                  style="cursor: pointer"
                  (click)="goTo('pointxagent')"
                    placement="bottom">
              <p [ngStyle]="{'color': sectionHeader?.color}" class="font-menu datos-header-right mb-0 pl-2" style="font-size: 12px !important; font-weight: 400;">Wallet</p>
              <div class="d-flex align-items-center pl-2 pr-4" style="border-right: 2px solid white;">
                <img src="../../../../assets/icons/header/wallet.svg" style="width: 18px;" alt="" >
                <p class="mb-0 ml-1"
                [ngStyle]="{'color': sectionHeader?.color}"
                     style="font-family: 'Poppins', sans-serif;font-size: 12px; font-weight: 600; ">
                    U$D {{ userService.creditBlickoins | number : '1.2-2'}}
                </p>
              </div>
            </div>
            <div class="d-flex flex-column"
                   tooltip="Límite de crédito"
                    placement="bottom">
               <p [ngStyle]="{'color': sectionHeader?.color}" class="font-menu datos-header-right mb-0 pl-2" style="font-size: 12px !important; font-weight: 400;">&nbsp;</p>
              <div class="d-flex align-items-center pl-2">
                <img src="../../../../assets/icons/header/creditLimit.svg" style="width: 20px;height: 18px;" alt="" >
                  <p [ngStyle]="{'color': sectionHeader?.color}"
                  class="mb-0 ml-1"
                  style="font-family: 'Poppins', sans-serif;font-size: 12px; font-weight: 600; ">
                  {{currencyAgency?.code}} {{ userService?.creditLimits | number : '1.2-2' }} LC
                </p>
              </div>
            </div>

          </div>
        </div>
        <div class="d-flex align-items-center pl-5" style="background-color: #f3f5f5">
          <div class="pr-3">
            <p [ngStyle]="{'color': sectionHeader?.color}" class=" mb-0" style="font-family: 'Poppins';font-size: 12px; font-weight: 400;">Fecha</p>
            <p [ngStyle]="{'color': sectionHeader?.color}" class=" mb-0" style="font-family: 'Poppins';font-size: 12px; font-weight: 600;">{{ fechaa }}</p>
          </div>
          <div class="px-3">
            <p [ngStyle]="{'color': sectionHeader?.color, 'cursor': permissionsMap['booking.ingresosinagencia'] ? 'pointer' : 'default'}"
                tooltip="{{permissionsMap['booking.ingresosinagencia'] ? 'Cambiar agencia' : ''}}"
                (click)="changeAgencyActive()"
                placement="bottom"
                class=" mb-0" style="font-family: 'Poppins';font-size: 12px; font-weight: 400;">Agencia {{ agencyName }}</p>
            <p [ngStyle]="{'color': sectionHeader?.color}" class=" mb-0" style="font-family: 'Poppins';font-size: 12px; font-weight: 600;">{{ username }}</p>
          </div>
          <div class="d-flex" style="gap:.5em;">
             <div style="width:38px; height: 38px;border-radius: 50%;border: 2.5px solid white;">
              <img *ngIf="agencyImagen"
                   class="imag-circle"
                   [src]="agencyImagen"
                   alt="Logo Agency"
                   tooltip="{{permissionsMap['booking.ingresosinagencia'] ? 'Cambiar agencia' : ''}}"
                   placement="bottom"
                   [ngStyle]="{'cursor': permissionsMap['booking.ingresosinagencia'] ? 'pointer' : 'default'}"
                   (click)="changeAgencyActive()">
            </div>
            <div class="mt-1" style="height: 34px; background-color: black; width: 3px"></div>
            <button type="button" class="close mt-1 pr-3" (click)="logout()" placement="bottom">
              <i class="bi bi-power" style="font-size: 30px; -webkit-text-stroke-width: 1.2px;" aria-hidden="true" ></i>
            </button>
          </div>
        </div>
      </div>

    </div>
    </div>



    <div [ngStyle]="{'visibility': permissionsMap['booking.itinerarios.crear'] ? 'visible' : 'hidden', 'background-color': sectionHeader?.background_itinerary_owner}" id="section-bottom" [ngClass]="{'hidden-section': shouldHideSection()}"
> <!---Aca-->
      <!-- <div id="section-bottom"  [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"> -->
      <usb-itinerary-owner *ngIf="currencyAgency"
                          [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                          [currencyAgency]="currencyAgency"
                          [currencies]="currencies"
      ></usb-itinerary-owner>
    </div>
  <!-- </ng-container> -->

</header>
